<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span class="d-flex justify-content-between align-items-center m-3">
        <span class="col-auto">
          <h2 class="mb-0">CDI Resolution</h2>
        </span>

        <span class="col-auto">
          <p-button
            label="Export Excel"
            variant="outlined"
            icon="pi pi-cloud-upload"
            severity="secondary"
            (click)="exportExcel()"
            class="fullwdth secondary-btn" />
        </span>
      </span>
      <div class="col-lg-12">
        <p-table
          #dt
          stripedRows
          [rowHover]="true"
          [rows]="50"
          [showCurrentPageReport]="true"
          [scrollable]="true"
          scrollHeight="calc(100vh - 310px)"
          [size]="'small'"
          [resizableColumns]="true"
          responsiveLayout="scroll"
          [value]="cdiList"
          styleClass="p-datatable-customers ordersListing search-more"
          [rowHover]="true"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 20, 50, 250, 1000]"
          [paginator]="true"
          [filterDelay]="0"
          [rows]="defaultTake"
          [lazy]="true"
          (onLazyLoad)="getCDIListing($event)"
          [totalRecords]="totalRecords"
          [globalFilterFields]="[]"
          sortMode="multiple"
          styleClass="table-listing">
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th
                style="width: 3rem"
                class="po"
                pSortableColumn="purchaseOrder">
                PO #
                <p-sortIcon field="purchaseOrder"></p-sortIcon>
              </th>
              <th class="vendor" pSortableColumn="vendorName">
                Vendor name
                <p-sortIcon field="vendorName"></p-sortIcon>
              </th>
              <th class="order" pSortableColumn="salesOrder">
                SO #
                <p-sortIcon field="salesOrder"></p-sortIcon>
              </th>
              <th class="customer" pSortableColumn="customer">
                Cust #
                <p-sortIcon field="customer"></p-sortIcon>
              </th>
              <th class="custname" pSortableColumn="customerName">
                Cust. Name
                <p-sortIcon field="customerName"></p-sortIcon>
              </th>
              <th class="number">Number</th>
              <th class="invoicedate" pSortableColumn="invoiceDate">
                Invoice Date
                <p-sortIcon field="invoiceDate"></p-sortIcon>
              </th>
              <th class="invoicetotal">Invoice Total</th>
              <th class="total">Sub Total</th>
              <th class="freight">Freight</th>
              <th class="tax">Tax</th>
              <th class="currency">JNI PO $$</th>
              <th class="unmat">Unmatched</th>
              <th class="assigned">Assigned</th>
              <th class="bconsultant" pSortableColumn="bcName">
                BC Name
                <p-sortIcon field="bcName"></p-sortIcon>
              </th>
              <th class="orderBacName" pSortableColumn="orderBacName">
                BAC Name
                <p-sortIcon field="orderBacName"></p-sortIcon>
              </th>
              <th class="reason">Reason</th>
              <th
                [ngClass]="{ trimmedby50char: descriptionCharacterCond }"
                class="note max-width-10">
                Note
              </th>
            </tr>

            <tr>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="purchaseOrder"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"
                    [showClearButton]="false"
                    [showApplyButton]="false"></p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="vendorName"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"
                    [showClearButton]="false"
                    [showApplyButton]="false"></p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="salesOrder"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"
                    [showClearButton]="false"
                    [showApplyButton]="false"></p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="customer"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"
                    [showClearButton]="false"
                    [showApplyButton]="false"></p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="customerName"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"
                    [showClearButton]="false"
                    [showApplyButton]="false"></p-columnFilter>
                </div>
              </th>
              <th></th>
              <th>
                <div class="d-flex justify-content-center">
                  <!-- <p-columnFilter
              type="text"
              field="invoiceDate"
              (input)="onFilterInput($event)"
              [showMenu]="false"
            ></p-columnFilter> -->
                  <jni-date-filter
                    (emitApplyFilter)="onFilterInput($event)"
                    (emitCanceFilter)="onFilterInput($event, 'clear')"
                    [columnName]="invoiceDateFieldName"
                    [filterMode]="filterMode"
                    [dataList]="cdiList">
                  </jni-date-filter>
                </div>
              </th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th class="d-flex justify-content-center">
                <jni-date-filter
                  (emitApplyFilter)="onFilterInput($event)"
                  (emitCanceFilter)="onFilterInput($event, 'clear')"
                  [columnName]="invoiceDateFieldName"
                  [filterMode]="filterMode"
                  [dataList]="cdiList">
                </jni-date-filter>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="bcName"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"></p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="orderBacName"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"></p-columnFilter>
                </div>
              </th>
              <th></th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-cdiList let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row"
              [pSelectableRow]="cdiList"
              [pSelectableRowIndex]="rowIndex"
              (click)="
                openCDI(
                  cdiList?.id,
                  cdiList?.purchaseOrder,
                  cdiList?.salesOrder,
                  cdiList?.recId
                )
              ">
              <td class="po">
                <a class="link"> {{ cdiList?.purchaseOrder }}</a>
              </td>
              <td class="vendor">{{ cdiList?.vendorName }}</td>
              <td class="salesOrder">{{ cdiList?.salesOrder }}</td>
              <td class="custNumber">
                {{ cdiList?.customer }}
              </td>
              <td class="custname">{{ cdiList?.customerName }}</td>
              <td class="number">{{ cdiList?.number }}</td>
              <td class="invoiceDate">
                <span *ngIf="cdiList?.invoiceDate | hidedynamicsdate">
                  {{ cdiList?.invoiceDate | date: "MM-dd-yyyy" }}
                </span>
              </td>
              <td class="invoicetotal text-right">
                {{
                  cdiList.invoiceTotal | currency: "USD" : "symbol" : "1.2-2"
                }}
              </td>
              <td class="subTotal text-right">
                {{ cdiList.subtotal | currency: "USD" : "symbol" : "1.2-2" }}
              </td>
              <td class="freight text-right">
                {{ cdiList?.freight | currency: "USD" : "symbol" : "1.2-2" }}
              </td>
              <td class="tax text-right">
                {{ cdiList?.tax | currency: "USD" : "symbol" : "1.2-2" }}
              </td>
              <td class="jnipo text-right">
                {{ cdiList?.jnipo | currency: "USD" : "symbol" : "1.2-2" }}
              </td>

              <td class="unmat text-right">
                {{ cdiList?.unmatched | currency: "USD" : "symbol" : "1.2-2" }}
              </td>
              <td class="assigned">
                <span *ngIf="cdiList?.assigned | hidedynamicsdate">
                  {{ cdiList?.assigned | date: "MM-dd-yyyy" }}
                </span>
              </td>
              <td class="bconsultant">
                {{ cdiList?.bcName }}
              </td>
              <td class="bconsultant">
                {{ cdiList?.orderBacName }}
              </td>
              <td class="reason">
                {{ cdiList?.reason }}
              </td>
              <td
                [ngClass]="{
                  'trimmeddescription trimmedby50char':
                    descriptionCharacterCond,
                }"
                class="note max-width-10 text-truncate">
                {{ descriptionCharacterCount(cdiList?.note)
                }}{{ cdiList?.note }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No CDI found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>
</div>

<!-- <div class="orders py-3 pagination-order">
  <header
    class="orders-header d-flex align-items-center justify-content-between has-border pb-2 mb-4">
    <h1>CDI Resolution</h1>
    <div class="orders-panel col-auto d-flex justify-content-between">
      <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
        <i class="icon-Export-excel me-2"></i>
        <a class="link" (click)="exportExcel()">Export excel</a>
      </div>
    </div>
  </header>
  
</div> -->

<jni-modal-stacker
  *ngIf="cdiSummaryDisplayModal"
  [displayModal]="cdiSummaryDisplayModal"
  (closeEvent)="closeModalForCDI()">
  <h1 class="panelHeading">CDI Resolution Summary</h1>
  <div class="panelBody">
    <jni-cdi-resolution-summary
      [CDIResolutionNumber]="CDIResolutionNumber"
      [poNumber]="poNumber"
      [saleOrderId]="saleOrderId"
      [cdiRecId]="recId"
      (closeEvent)="closeModalForCDI()"></jni-cdi-resolution-summary>
  </div>
</jni-modal-stacker>
